import { ThisConnector } from '../../connector'
import { BaseApiResponse } from '../../shared'

export interface PostFreeTrialActivationArgs {
  freeTrialToken: string
  password: string
}

export interface PostFreeTrialActivationResponse extends BaseApiResponse {
  organization_uuid: string
}

export async function postFreeTrialActivation(
  this: ThisConnector,
  { freeTrialToken, password }: PostFreeTrialActivationArgs
) {
  return this.connector.post<PostFreeTrialActivationResponse>(
    'public/ng/free-trial/activation',
    { token: freeTrialToken, password }
  )
}
